import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-validation',
  templateUrl: './custom-validation.component.html',
  styleUrls: ['./custom-validation.component.scss']
})
export class CustomValidationComponent implements ICellRendererAngularComp {

  public cellValue: any;
  public params: any;
  public isCellValue: any;
  public disablePointerEvent: boolean = false;
  constructor() { }

  agInit(params: any) {
    this.params = params;
    this.cellValue = params.value;
    if (this.cellValue) {
      this.isCellValue = true;
    } else {
      this.isCellValue = false;
    }

    //Below line is for LTC Nutrition change component
    if (params && params.sourcePage && params.sourcePage === 'LTCNutritionChange') {
      if (params && params.data && params.data.ltcNutritionStatusChangeId === 0) {
        this.disablePointerEvent = false;
      }
      else {
        this.disablePointerEvent = true;
      }
    }
  }

  clearText() {
    this.cellValue = '';
    this.params.data[this.params.column.colId] = '';
    this.params.context.componentParent.customRefresh(this.params.column.colId);
    this.isCellValue = false;
  }

  onCellEdit(event) {
    const inp = String.fromCharCode(event.keyCode);
    const colId = this.params.column.colId;

    if (colId === "rdnAssessedPatient") {
      return this.validateRdnInput(event);
    } else if (colId === "daysNPO") {
      return this.validateDaysNPO(event, inp);
    } else if (colId === "bmi") {
      return this.validateBmi(event, inp);
    } else {
      return this.validateDefault(event, inp);
    }
  }

  private validateRdnInput(event): boolean {
    const keycode = event.currentTarget.value + event.key;
    if ((/^[-a-zA-Z0-9' ]*(?:,[-a-zA-Z0-9' ]*)?$/).test(keycode)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  private validateDaysNPO(event, inp: string): boolean {
    if (event.currentTarget.value.length >= 3) {
      event.preventDefault();
      return false;
    }
    if ((/^[0-9]+$/).test(inp)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  private validateBmi(event, inp: string): boolean {
    if (event.currentTarget.value.length >= 5) {
      event.preventDefault();
      return false;
    }
    if ((/^[0-9.]+$/).test(inp)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  private validateDefault(event, inp: string): boolean {
    if ((/^[0-9A-Za-z.]+$/).test(inp)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  updateCellValue() {
    this.params.data[this.params.column.colId] = this.cellValue;
    this.params.context.componentParent.customRefresh(this.params.column.colId);
  }

  refresh(): boolean {
    return false;
  }

}